<template>
  <div class="modal-reserve-schedule-container">
    <sweet-modal ref="dateModal" overlay-theme="dark"
      @close="setDefault">
      <div class="modal-title">서비스 일정 수정</div>
      <div v-if="item" class="content">
        <div class="box-resv">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.71 7.21001C18.617 7.11628 18.5064 7.04189 18.3846 6.99112C18.2627 6.94035 18.132 6.91422 18 6.91422C17.868 6.91422 17.7373 6.94035 17.6154 6.99112C17.4936 7.04189 17.383 7.11628 17.29 7.21001L9.84 14.67L6.71 11.53C6.61348 11.4368 6.49954 11.3635 6.37468 11.3143C6.24983 11.2651 6.1165 11.2409 5.98232 11.2432C5.84814 11.2456 5.71573 11.2743 5.59265 11.3278C5.46957 11.3813 5.35824 11.4585 5.265 11.555C5.17176 11.6515 5.09845 11.7655 5.04924 11.8903C5.00004 12.0152 4.97591 12.1485 4.97823 12.2827C4.98055 12.4169 5.00928 12.5493 5.06277 12.6724C5.11627 12.7954 5.19348 12.9068 5.29 13L9.13 16.84C9.22296 16.9337 9.33356 17.0081 9.45542 17.0589C9.57728 17.1097 9.70799 17.1358 9.84 17.1358C9.97201 17.1358 10.1027 17.1097 10.2246 17.0589C10.3464 17.0081 10.457 16.9337 10.55 16.84L18.71 8.68001C18.8115 8.58637 18.8925 8.47272 18.9479 8.34622C19.0033 8.21972 19.0319 8.08312 19.0319 7.94501C19.0319 7.80691 19.0033 7.67031 18.9479 7.54381C18.8925 7.41731 18.8115 7.30366 18.71 7.21001Z"
                  fill="#FFCEA6"/>
          </svg>
          <div class="title-resv">해당회차 예약</div>
          <div class="count-resv">{{ item.ordered_count }}건</div>
        </div>

        <div class="grid-item">
          <div class="grid-title">운영시간</div>
          <div>
            <admin-form-item label="운영시간">
              <admin-date-picker type="date" :disabled="item.ordered_count>0"
                                 :data.sync="item.start_date"></admin-date-picker>
              <time-range-picker
                start_placeholder="시작시간" end_placeholder="종료시간" :disabled="item.ordered_count>0"
                :start_time.sync="item.start_time" :end_time.sync="item.end_time" :unit="5"/>
            </admin-form-item>
            <div v-if="item.ordered_count>0" style="margin-top:8px"
              class="primary size-13">*예약건이 있는 경우 서비스 시간 변경 불가</div>
          </div>
        </div>

        <div class="grid-item">
          <div class="grid-title">모집인원</div>
          <!-- 옵션X -->
          <div v-if="reservePolicy.limit_type === 0 || (reservePolicy.limit_type === 1 && (!item.selectorStocks || item.selectorStocks.length === 0))" >
            <div class="flex" style="gap: 0 8px">
              <div class="flex-1">
                <div class="size-13 weight-700">모집인원</div>
                <div v-if="!item.stock_infinite" class="flex-align" style="margin-top: 8px; gap:0 4px">
                  <input type="number" v-model="item.stock" style="width:80px">
                  <div class="size-13">명</div>
                </div>
                <div style="margin-top: 8px">
                  <lp-check-bool :checked-val.sync="item.stock_infinite"
                                :labelStyle="{fontSize: '13px', color:'#787878'}"
                                label="무한대"></lp-check-bool>
                </div>
              </div>
              <div class="flex-1">
                <div class="size-13 weight-700">예약인원</div>
                <div class="primary size-14" style="margin-top: 8px">{{ item.ordered_count }}명</div>
              </div>
            </div>
            <div v-if="item.ordered_count>0 && !item.stock_infinite &&
                       item.stock < item.ordered_count" style="margin-top:8px"
                 class="primary size-13">*예약인원보다 최대인원이 적을 수 없습니다.</div>
          </div>
          <!-- 옵션 -->
          <div v-else class="option-wrap">
            <div class="grid-opt">
              <div class="opt-header">옵션명</div>
              <div class="opt-header text-center">모집인원</div>
              <div class="opt-header text-center">예약인원</div>
            </div>
            <div class="grid-opt option-item-wrap" v-for="(opt,idx) in item.selectorStocks" :key="`stock-opt-${idx}`">

              <div class="flex-align option-item wrap" style="white-space: nowrap !important">
                <div v-for="(child,cidx) in opt.options" :key="`opt-name-${cidx}`" class="flex-align">
                  <div class="opt-name-child">{{ child.name }}</div>
                  <div class="opt-name-divider" v-if="cidx < opt.options.length-1"></div>
                </div>
              </div>
              <div class="option-item">
                <div class="flex-align" style="gap:0 4px; margin-bottom: 8px">
                  <input type="number" v-model="opt.stock" style="width:80px" :disabled="!opt.enable_stock">
                  <div class="size-13">명</div>
                </div>
                <lp-check-bool :checked-val="!opt.enable_stock"
                               @onCheck="res => opt.enable_stock = !res"
                               :labelStyle="{fontSize: '13px', color:'#787878'}"
                               label="무한대"></lp-check-bool>
              </div>
              <div class="option-item flex-center size-14 ordered-count">{{ opt.ordered_count }}명</div>
            </div>
          </div>
        </div>

        <div class="grid-item">
          <div class="grid-title">인원 적용범위</div>
          <div>
            <lp-radio :val.sync="range.stock"
                      :block="true"
                      value_name="value"
                      label_name="label"
                      :data="option.stock"></lp-radio>
          </div>
        </div>

        <div class="grid-item">
          <div class="grid-title">가격</div>
          <div>
            <div style="width:262px">
              <div class="flex-align" style="margin-bottom:12px">
                <input class="input-border text-right" type="number"
                       placeholder="0" min="0" v-model.number="item.price">
                <div class="size-14" style="margin-left:4px">원</div>
              </div>
              <div class="flex-align" style="gap:0 12px">
                <select class="input-border" style="flex:1" v-model="item.discount_type">
                  <option :value="-1">할인없음</option>
                  <option :value="0">할인율</option>
                  <option :value="1">금액할인</option>
                </select>
                <div class="flex-align" style="flex:1">
                  <div v-if="item.discount_type===0" class="flex-align">
                    <input class="input-border text-right" type="number"
                           placeholder="0" min="0" v-model.number="item.discount_rate">
                    <div class="size-14" style="margin-left:4px">%</div>
                  </div>
                  <div v-else-if="item.discount_type===1" class="flex-align">
                    <input class="input-border text-right" type="number"
                           placeholder="0" min="0" v-model.number="item.discount_price">
                    <div class="size-14" style="margin-left:4px">원</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="size-14" style="margin-top:12px"
                 v-if="item.discount_type>-1">할인 후 가격<b style="margin-left:8px">{{ calcDiscount|currency }}</b></div>
            <template v-if="item.org">
              <div class="divider"></div>
              <div class="flex-align unselect"
                   @click="clickRefresh">
                <img :src="svgSrc('refresh')">
                <div class="size-13" style="color:#787878">기본 가격으로 재설정</div>
              </div>
            </template>
          </div>
        </div>

        <div class="grid-item">
          <div class="grid-title">가격 적용범위</div>
          <div>
            <lp-radio :val.sync="range.price"
                      :block="true"
                      value_name="value"
                      label_name="label"
                      :data="option.stock"></lp-radio>
          </div>
        </div>
      </div>
      <div class="btn-group" v-if="item">
        <div v-if="item.ordered_count>0"
             class="primary size-13">*예약건이 있는 경우 서비스 삭제 불가</div>
        <button class="button is-light" @click="clickCancel">취소</button>
        <button v-if="item.ordered_count===0"
          class="button is-light" @click="clickDelete">삭제</button>
        <button class="button is-primary" @click="clickAccept">저장</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpTimePicker from "../../../module/common/LpTimePicker";
  import AdminTimePicker from "../../../module/admin/AdminTimePicker";
  import TimeRangePicker from "../../../module/common/timeRangePicker";
  import TimePicker from "../../../module/common/TimePicker";
  import moment from 'moment';

  export default {
    name: 'ModalReserveScheduleUpdate',
    components: {
      TimePicker,
      TimeRangePicker,
      AdminTimePicker,
      LpTimePicker,
      LpCheckBool,
      LpRadio,
      SweetModal
    },
    props: {
      prod: {
        type: Object
      },
      selectedTime: {
        type: Object
      },
      reservePrice: {
        type: Array
      },
      reservePolicy: {
        type: Object
      }
    },
    mounted() {
    },
    methods: {
      open() {
        this.item = this.cloneItem(this.selectedTime);
        if (this.item.selectorStocks.length > 0) {
          this.item.selectorStocks.sort((a, b) => {
            return a.id - b.id
          })
        }
        setTimeout(()=>{
          this.$refs.dateModal.open();
          this.$nextTick(() => {
            this.$refs.dateModal.$el.children[0].scrollTop = 0;
          })
        }, 100);
      },
      clickRefresh() {
        let current = moment(this.item.start_date);
        let price = this.reservePrice.filter(i => moment(i.start_date).isSameOrBefore(current) && (
          (!i.end_date || i.end_date === '') || (i.end_date && i.end_date !== '' && moment(i.end_date).isSameOrAfter(current))
        ));
        if(price.length>0) {
          price = price[0];
          ['price','is_discount','discount_price','discount_rate','sale_price','discount_type'].forEach(k=>{ this.item[k] = price[k] });
        }
      },
      clickRefreshOption() {

      },
      setDefault() {
        this.range.price = 0;
        this.range.stock = 0;
      },
      clickCancel() {
        this.setDefault();
        this.$refs.dateModal.close();
      },
      clickDelete() {
        this.$axios.delete(this.getUrl(`reservation/product/${this.prod.id}/schedule/${this.item.id}`)).then(res=> {
          if(res.status === 200) {
            this.$emit('accept');
            this.$refs.dateModal.close();
            this.toastStatus('일정이 삭제되었습니다.');
          }
        }).catch(()=> {
          this.toastStatus('일정 삭제에 실패했습니다.');
        })
      },
      clickAccept() {
        if(this.item.ordered_count>0 && !this.item.stock_infinite &&
          this.item.stock < this.item.ordered_count) {
          this.toast('예약 인원보다 최대 인원이 적을 수 없습니다.');
          return;
        }

        this.item.is_discount = this.item.discount_type > -1;
        if(this.item.discount_type === 0) {
          this.item.sale_price = this.item.price - (this.item.price * (this.item.discount_rate / 100))
        } else if(this.item.discount_type === 1) {
          this.item.sale_price = this.item.price - this.item.discount_price;
        } else {
          this.item.sale_price = this.item.price;
        }

        let param = Object.assign(this.item, {range: this.range});

        this.$axios.patch(this.getUrl(`reservation/product/${this.prod.id}/schedule/${this.item.id}`), param).then(res=> {
          if(res.status === 200) {
            this.$emit('accept');
            this.$refs.dateModal.close();
            this.toastStatus('일정이 수정되었습니다.');
          }
        }).catch(()=> {
          this.toastStatus('일정 수정에 실패했습니다.');
        })
      },
    },
    computed: {
      calcDiscount() {
        let price = 0;
        if(this.item.discount_type === 0) {
          price = this.item.price - (this.item.price * (this.item.discount_rate / 100))
        } else {
          price = this.item.price - this.item.discount_price;
        }
        return price;
      }
    },
    data() {
      return {
        item: undefined,
        range: {
          stock: 0,
          price: 0
        },
        option: {
          stock: [
            {
              label: '해당 회차에만 적용',
              value: 0
            },
            {
              label: '이후 반복일정에서의 이 회차 일괄 적용',
              detail: '(개별로 수정한 일정은 적용되지 않습니다.)',
              value: 1
            },
            {
              label: '이후 모든 회차에 적용',
              value: 2
            }
          ]
        },
      }
    },
    watch: {
      'item.stock_infinite'(n) {
        if (n) {
          this.item.stock = 0;
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $primary = #ff5722

  .modal-reserve-schedule-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .input-border
    border 1px solid #cccccc
    border-radius 4px
    padding 7px
    width 100%
    flex 1
  input[type=number]
    color #363636
    text-align left
    padding-left 12px

  .grid-item
    display grid
    grid-template-columns 120px 1fr
    column-gap 8px
    padding-bottom 28px
    border-bottom 1px solid #eeeeee
    margin-bottom 28px
  .grid-item:last-child
    margin-bottom 0
    border-bottom 0

  .border-bottom-0
    border-bottom 0

  .divider
    width 100%
    height 1px
    background-color #eeeeee
    margin 12px 0

  .grid-title
    font-size 14px


  .opt-item
    flex 1
    border 1px solid #dddddd
    background-color #F5F5F5
    border-radius 4px
    padding 12px 15px
    color #363636
    .circle
      background-color white
      border 1px solid #cccccc
      border-radius 100%
      width 16px
      height 16px
    .desc
      color #787878
      font-size 13px
      margin-top 4px

  .opt-item-selected
    border 1px solid $primary
    background-color #fff0eb
    .circle
      border 3px solid $primary
    .opt-label
      color $primary

  .auto-setting
    font-size 13px
    .grid-auto
      display grid
      grid-template-columns 80px 1fr
      grid-column-gap 4px
      align-items center
    .sub3
      color #aeaeae
      margin-bottom 4px
    input[type=number]
      color #363636
      text-align left
      padding-left 8px

  .text-right
    text-align right !important

  .option-wrap
    border 1px solid #eeeeee
  .grid-opt
    display grid
    grid-template-columns 1fr 140px 110px
    align-items center
  .opt-header
    color #787878
    background-color #f5f5f5
    border-bottom 1px solid #eeeeee
    padding 10px 12px
    font-size 14px
    font-weight 500
    border-right 1px solid #eeeeee
  .opt-header:last-child
    border-right 0

  .option-item-wrap
    height 80px
    border-bottom 1px solid #eeeeee
  .option-item-wrap:last-child
    border-bottom 0
  .option-item
    height 80px
    border-right 1px solid #eeeeee
    padding 10px 12px
  .option-item:last-child
    border-right 0
  .ordered-count
    color $primary
  .opt-name
    display flex
    flex-wrap wrap
  .opt-name-child
    font-size 14px
    color #323232
    padding-right 4px

  .opt-name-divider
    width 1px
    height 14px
    background-color #dddddd
    margin-right 4px

  .box-resv
    background-color #4A4A4A
    padding 12px 16px
    margin-bottom 28px
    font-size 14px
    display flex
    align-items center
    .title-resv
      color white
      margin 0 6px 0 8px
    .count-resv
      color #FFCEA6


  .btn-group
    display flex
    align-items center
    justify-content flex-end
    gap 0 12px
</style>

<style lang="stylus">
  .sweet-modal-overlay
    -webkit-perspective initial

  .modal-reserve-schedule-container
    .sweet-modal.is-alert
      width 620px
      max-height 90vh
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px

    .mx-datepicker
      width 190px
    .time-picker-container
      min-width 140px
</style>
